import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import BaselineForm from '../../components/Baselines/BaselineForm';
import baselineService from '../../services/baselineService';

const BaselineEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [baseline, setBaseline] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchBaseline();
  }, [id]);

  const fetchBaseline = async () => {
    try {
      setLoading(true);
      const data = await baselineService.getBaselineById(id);
      setBaseline(data.baseline);
      setError(null);
    } catch (err) {
      setError(err.message || 'Failed to fetch baseline');
      console.error('Error fetching baseline:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (formData) => {
    try {
      await baselineService.updateBaseline(id, formData);
      alert('Baseline updated successfully!');
      navigate('/app/baselines');
    } catch (error) {
      alert(error.message || 'Failed to update baseline');
      throw error;
    }
  };

  const handleCancel = () => {
    navigate('/app/baselines');
  };

  if (loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <div style={{
          width: '50px',
          height: '50px',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #007bff',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 1rem'
        }}></div>
        <p>Loading baseline...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <p style={{ color: '#dc3545', marginBottom: '1rem' }}>{error}</p>
        <button onClick={() => navigate('/app/baselines')} className="btn btn-primary">
          Back to Baselines
        </button>
      </div>
    );
  }

  return (
    <div className="baseline-edit-page" style={{ padding: '2rem', maxWidth: '1400px', margin: '0 auto' }}>
      <div className="page-header" style={{ marginBottom: '2rem' }}>
        <button 
          onClick={handleCancel}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            background: 'none',
            border: 'none',
            color: '#007bff',
            cursor: 'pointer',
            fontSize: '1rem',
            marginBottom: '1rem'
          }}
        >
          <FiArrowLeft /> Back to Baselines
        </button>
        <h1 style={{ margin: 0, fontSize: '2rem', fontWeight: '700' }}>Edit Baseline</h1>
        <p style={{ margin: '0.5rem 0 0 0', color: '#6c757d' }}>
          Update baseline information
        </p>
      </div>

      {baseline && (
        <BaselineForm 
          baseline={baseline} 
          onSubmit={handleSubmit} 
          onCancel={handleCancel} 
        />
      )}
    </div>
  );
};

export default BaselineEdit;


